import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HttpCommonService} from '../../../../../shared/services/http-common.service';
import {Observable} from 'rxjs';
import {GenericHttpResponse} from '../../../../../shared/services/interfaces/generic-http-response.interface';
import {Contacto, ContactoFiltros, ContactoPaginatedResponse, ContactoPayload, ContactoResponse} from './contactos.interface';

@Injectable({
  providedIn: 'root'
})
export class ContactosService {
  private http = inject(HttpClient);
  private httpCommonService = inject(HttpCommonService);

  index(page: number = 1, perPage: number = 15, filtros: Partial<ContactoFiltros> = {}): Observable<GenericHttpResponse<ContactoPaginatedResponse>> {
    const params: any = {
      page,
      per_page: perPage,
      ...filtros
    };
    // Eliminar propiedades vacías
    Object.keys(params).forEach(key => {
      if (params[key] === '' || params[key] === null || params[key] === undefined) {
        delete params[key];
      }
    });
    const url = this.httpCommonService.makeUrl('/crms/contactos', params);
    return this.http.get<GenericHttpResponse<ContactoPaginatedResponse>>(url);
  }

  show(id: number): Observable<GenericHttpResponse<Contacto>> {
    const url = this.httpCommonService.makeUrl(`/crms/contactos/${id}`);
    return this.http.get<GenericHttpResponse<Contacto>>(url);
  }

  store(body: ContactoPayload): Observable<GenericHttpResponse<ContactoResponse>> {
    const url = this.httpCommonService.makeUrl('/crms/contactos');
    return this.http.post<GenericHttpResponse<ContactoResponse>>(url, body);
  }

  update(id: number, body: ContactoPayload): Observable<GenericHttpResponse<ContactoResponse>> {
    const url = this.httpCommonService.makeUrl(`/crms/contactos/${id}`);
    return this.http.put<GenericHttpResponse<ContactoResponse>>(url, body);
  }

  destroy(id: number): Observable<GenericHttpResponse<ContactoResponse>> {
    const url = this.httpCommonService.makeUrl(`/crms/contactos/${id}`);
    return this.http.delete<GenericHttpResponse<ContactoResponse>>(url);
  }
}
